import moment from 'moment';
import { isEmpty, startsWith, replace } from 'lodash';

/**
 * @type {function}
 * @desc Get time elapsed since or between ISO `date` string(s).
 * @example
 * import { timeElapsed } from 'utils/time';
 * const result = time( ...args );
 */
export const timeElapsed = ( startDate, endDate ) => {
    
    // duration in `HH:MM:SS` format.
    let duration;
    
    // calculate duration based on `startDate` and `endDate`
    if( isEmpty( startDate ) ) {
        duration = '00:00:00';
    } else if ( isEmpty( endDate ) ) {
        duration = moment.utc( moment.utc().diff( moment.utc( startDate ) ) ).format( 'HH:mm:ss' );
    } else {
        duration = moment.utc( moment.utc( endDate ).diff( moment.utc( startDate ) ) ).format( 'HH:mm:ss' );
    }

    // if `HH;` part is `00:`, remove it
    if( startsWith( duration, '00:' ) ) {
        return replace( duration, '00:', '' );
    } else {
        return duration;
    }
};
